import React from 'react'
import { Control } from 'react-hook-form'
import { FormItem } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'

interface Props {
    control: Control<any>
}

const TicketMarjorable: React.FC<Props> = ({ control }) => {
    const { t } = useTranslation()
    return (
        <FormItem
            control={control}
            name="ticket_marjorable"
            type="checkbox"
            label={t('Major Incident')}
        />
    )
}

export default TicketMarjorable
